import apiClient from '../apiClient';
import { API_ENDPOINTS } from '../endpoints';

export interface BroadcastRoomOption {
  roomId: string;
  betAmount: number;
}

export interface BroadcastButton {
  label: string;
  roomId: string;
}

export interface BroadcastImagePayload {
  dataUrl: string;
  filename?: string;
}

export interface SendBroadcastInput {
  text: string;
  image?: BroadcastImagePayload | null;
  buttons?: BroadcastButton[];
}

export interface BroadcastResult {
  total: number;
  sent: number;
  failed: number;
}

interface ApiEnvelope<T> {
  success: boolean;
  data: T;
  message?: string;
}

class PostService {
  async getRooms(): Promise<BroadcastRoomOption[]> {
    const res = await apiClient.get<ApiEnvelope<BroadcastRoomOption[]>>(
      API_ENDPOINTS.POST.GET_ROOMS
    );
    return res.data.data;
  }

  async sendBroadcast(input: SendBroadcastInput): Promise<BroadcastResult> {
    const res = await apiClient.post<ApiEnvelope<BroadcastResult>>(
      API_ENDPOINTS.POST.SEND_BROADCAST,
      input,
      {
        // Images can push JSON past the default; be generous.
        timeout: 120000,
        maxBodyLength: 25 * 1024 * 1024,
      }
    );
    return res.data.data;
  }
}

const postService = new PostService();
export default postService;